import {
  TASK_BOARD_VIEW_TYPE,
  TASK_PRIORITY,
  TASK_STATUS,
  VIEW_MODE_TYPE_LANES_MAPPING,
} from '../../../common/constants/TaskConstants';
import {
  fetchTaskForBoardView,
  refreshTaskForBoardView,
} from '../../routines/taskRoutines';

const { OPEN, PLANNED, IN_PROGRESS, BLOCKED, COMPLETED } = TASK_STATUS;
const { NONE, LOW, HIGH, NORMAL, URGENT } = TASK_PRIORITY;

const dateBreakDownInitial = {
  all: 0,
  overDue: 0,
  thisWeek: 0,
  today: 0,
  unscheduled: 0,
};

const getBoardViewInitialState = (boardViewType) => {
  return Object.values(VIEW_MODE_TYPE_LANES_MAPPING[boardViewType]).reduce(
    (acc, { key }) => {
      return {
        ...acc,
        [key]: {
          data: [],
          loading: true,
          dateBreakDown: dateBreakDownInitial,
        },
      };
    },
    {}
  );
};

const initialState = {
  taskList: {},
  paginationData: { totalItems: 0, page: 0 },
  currentPayload: null, // the payload used for the current result set
  needToLoad: [],
  taskListLoading: true,
  taskCompleting: false,
  taskResolving: false,
  taskResolvingSuccess: false,
  taskInProgressMarking: false,
};

const taskReducer = (state = initialState, action) => {
  switch (action.type) {
    case fetchTaskForBoardView.TRIGGER: {
      const { payload } = action;
      const { page, boardViewType = TASK_BOARD_VIEW_TYPE.STATUS } = payload;

      if (page === 1) {
        return {
          ...initialState,
          needToLoad:
            boardViewType === TASK_BOARD_VIEW_TYPE.STATUS
              ? [OPEN, PLANNED, IN_PROGRESS, BLOCKED, COMPLETED]
              : [NONE, LOW, NORMAL, HIGH, URGENT],
          taskList: {
            data: { ...getBoardViewInitialState(boardViewType) },
            loading: true,
            boardViewType,
          },
        };
      }
      const taskListData = Object.values(
        VIEW_MODE_TYPE_LANES_MAPPING[boardViewType]
      ).reduce((acc, { key }) => {
        acc[key] = {
          ...state.taskList.data[key],
          loading: state.needToLoad.includes(key),
        };
        return acc;
      }, {});

      const totalItems = Object.values(
        VIEW_MODE_TYPE_LANES_MAPPING[boardViewType]
      ).reduce((acc, { key }) => {
        if (state.needToLoad.includes(key)) {
          return acc;
        }
        return acc + state.taskList?.data[key]?.totalItemCount;
      }, 0);

      return {
        ...state,
        taskListLoading: true,
        taskList: {
          ...state.taskList,
          data: {
            ...state.taskList.data,
            ...taskListData,
          },
        },
        paginationData: {
          ...state.paginationData,
          totalItems,
        },
      };
    }
    case fetchTaskForBoardView.SUCCESS: {
      const { response, currentPayload, key } = action.payload;
      const { needToLoad: _needToLoad } = state;
      const { tasks = [] } = response;
      const needToLoad =
        tasks.length === 0
          ? _needToLoad.filter((item) => item !== key)
          : _needToLoad;
      return {
        ...state,
        needToLoad,
        taskListLoading: false,
        taskList: {
          ...state.taskList,
          data: {
            ...state.taskList.data,
            [key]: {
              data: [
                ...state.taskList.data[key].data,
                ...(response.tasks || []),
              ],
              totalItemCount: response.totalItemCount,
              loading: false,
              dateBreakDown: response.dateBreakDown,
            },
          },
        },
        paginationData: {
          page: response.page,
          pageSize: response.pageSize,
          totalItems:
            state.paginationData?.totalItems + response.totalItemCount,
        },
        currentPayload,
      };
    }
    case fetchTaskForBoardView.FAILURE:
    case fetchTaskForBoardView.FULFILL:
      return {
        ...state,
        taskListSuccess: false,
      };
    case refreshTaskForBoardView.TRIGGER:
      return {
        ...state,
        taskListLoading: true,
      };
    case refreshTaskForBoardView.SUCCESS: {
      const { response } = action.payload;
      return {
        ...state,
        taskListLoading: false,
        taskList: {
          ...state.taskList,
          data: response.reduce((acc, cur) => {
            acc[cur.key] = {
              data: cur.response.data.tasks,
              loading: false,
              totalItemCount: cur.response.data.totalItemCount,
              dateBreakDown: cur.response.data.dateBreakDown,
            };
            return acc;
          }, {}),
        },
      };
    }
    case refreshTaskForBoardView.FAILURE:
      return {
        ...state,
        taskListLoading: false,
      };
    default:
      return state;
  }
};

export default taskReducer;
